// Базовые скрипты сайта
require('./core');

// Скрипты публичных страниц сайта
require('./worldwide');